"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateZipCode = void 0;
const graphql_1 = require("../graphql");
const order_1 = require("../types/order");
const validateZipCode = async (pincode, paymentType, resolve) => {
    try {
        if (pincode) {
            const { data: { getZipCode: response }, } = await resolve(graphql_1.getZipCode, { id: pincode });
            if (response) {
                if (paymentType === order_1.ADDRESS_PAYMENT_METHODS.ALL)
                    return true;
                if (paymentType == order_1.ADDRESS_PAYMENT_METHODS.PREPAID)
                    return !!response.prepaid;
                return !!response.cod;
            }
        }
    }
    catch (_a) { }
    return false;
};
exports.validateZipCode = validateZipCode;
